var _style, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{fill:#A2001D;}\n\t.st2{fill:#FFDA44;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,512c31.3,0,61.3-5.6,89-15.9L356.2,256L345,15.9C317.3,5.6,287.3,0,256,0s-61.3,5.6-89,15.9L155.8,256 L167,496.1C194.7,506.4,224.7,512,256,512z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,256c0,110.1,69.5,203.9,167,240.1V15.9C69.5,52.1,0,145.9,0,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345,15.9v480.2c97.5-36.2,167-130,167-240.1S442.5,52.1,345,15.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.4,256h22.3v89h-22.3V256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.4,256h22.3v89H33.4V256z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 89,
    cy: 289.4,
    r: 22.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 89,
    cy: 211.5,
    r: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.8,322.8h44.5V345H66.8L66.8,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.8,233.7h44.5V256H66.8L66.8,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89,133.6l7.9,24.3h25.5l-20.6,15l7.9,24.3l-20.6-15l-20.6,15l7.9-24.3l-20.6-15h25.5L89,133.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.fad344b7f204d8460f45f3171d218eb4.svg";
export { ForwardRef as ReactComponent };